import React from 'react';
import { Box, Flex, Text, Link } from '@chakra-ui/core';

import theme, { colors } from '@styles/theme-chakra';

const Section = ({ n, title, lineItems = [], onClose }) => {
  return (
    <Flex w={['23rem', '600px']} pt={[2, 0]} direction="column">
      <Box pt={[4, 6]}>
        <Box
          pt={1}
          align="center"
          backgroundColor={colors.white}
          border="1px"
          bordercolor={colors.black}
          h="2rem"
          w="4rem"
          rounded="2xl"
        >
          <Text fontSize={theme.fontSizes.sm} color={colors.black}>
            Part {n}
          </Text>
        </Box>
        <Text
          as="h4"
          w="22rem"
          pt={[6, 4]}
          fontSize={['16px', '25px']}
          fontWeight={theme.fontWeights.bold}
        >
          {title}
        </Text>
        <Box pb={[3, 0]}>
          {lineItems.map((i, idx) => (
            <Link onClick={onClose} key={idx} href={i.href}>
              <Text
                w="20rem"
                fontWeight={theme.fontWeights.semibold}
                fontSize={['10px', '14px']}
                decoration="underline"
                pt={[4, 2]}
              >
                {i.item}
              </Text>
            </Link>
          ))}
        </Box>
      </Box>
    </Flex>
  );
};

export default Section;
